// extracted by mini-css-extract-plugin
module.exports = {"baseRoot":"baseRoot___39Tuf","main":"main___3Xzb_","contentDiv":"contentDiv___J-I8o","pSpan1":"pSpan1___1nx0i","pSpan2":"pSpan2___226oI"};